var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A7A8AA",
    d: "M12 2.25A9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12 9.75 9.75 0 0 1 12 2.25M7.714 6.857a.857.857 0 0 0 0 1.714h.455a5.144 5.144 0 1 0 5.374-1.479.858.858 0 0 0-.515 1.637 3.43 3.43 0 1 1-3.6 1.004v.553a.857.857 0 0 0 1.715 0V7.714a.857.857 0 0 0-.857-.857z"
  })));
};
export default SvgRepeat;